module.exports = __webpack_public_path__ + "media/images/bnr-early-sm-8068d6cc39a6c58cf2e722142150d37d.png";